<div>
    <p-button [label]="buttonText"
    (click)="search()" [disabled]="searching" iconPos="right" [icon]="searchIcon"></p-button>
</div>